export const INITIAL_CONTEXT_MODEL_STATE = {
    project: {},
    variables: {},
    globals: {},
    inputs: {}
};
